import React from 'react';

type SHImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  imagePath: string;
};
const S3StaticImage: React.FC<SHImageProps> = ({ imagePath, ...props }) => {
  const baseUrl = process.env.REACT_APP_S3_STATIC_IMAGE_URL;
  if (!baseUrl) {
    console.warn(
      'REACT_APP_S3_STATIC_IMAGE_URL is not defined in environment variables',
    );
    return null;
  }
  const src = `${baseUrl}/${imagePath}`;
  return <img src={src} loading="lazy" {...props} />;
};
export default S3StaticImage;
